import { apiClient } from './client';
import type { PaginatedResponse, PaginationParams, MessageResponse } from '../types/api';
import type { AdminTicketListItem, AdminTicketDetail, AdminTicketCreateRequest, AdminTicketUpdateRequest, AdminTicketReplyRequest, AdminEmailTemplateItem, AdminEmailTemplateDetail, AdminEmailTemplateCreateRequest, AdminEmailTemplateUpdateRequest, AdminEmailPreviewRequest, AdminEmailPreviewResponse } from '../types/support';

export const supportApi = {
  listTickets: (params: PaginationParams & { status?: string; priority?: string; assigned_to?: string }) =>
    apiClient.get<PaginatedResponse<AdminTicketListItem>>('/support/tickets', { params }).then((r) => r.data),
  createTicket: (data: AdminTicketCreateRequest) =>
    apiClient.post<AdminTicketDetail>('/support/tickets', data).then((r) => r.data),
  ticketDetail: (id: string) =>
    apiClient.get<AdminTicketDetail>(`/support/tickets/${id}`).then((r) => r.data),
  updateTicket: (id: string, data: AdminTicketUpdateRequest) =>
    apiClient.patch<MessageResponse>(`/support/tickets/${id}`, data).then((r) => r.data),
  replyToTicket: (id: string, data: AdminTicketReplyRequest) =>
    apiClient.post<MessageResponse>(`/support/tickets/${id}/reply`, data).then((r) => r.data),

  listTemplates: () =>
    apiClient.get<AdminEmailTemplateItem[]>('/support/email-templates').then((r) => r.data),
  createTemplate: (data: AdminEmailTemplateCreateRequest) =>
    apiClient.post<AdminEmailTemplateDetail>('/support/email-templates', data).then((r) => r.data),
  templateDetail: (id: string) =>
    apiClient.get<AdminEmailTemplateDetail>(`/support/email-templates/${id}`).then((r) => r.data),
  updateTemplate: (id: string, data: AdminEmailTemplateUpdateRequest) =>
    apiClient.patch<AdminEmailTemplateDetail>(`/support/email-templates/${id}`, data).then((r) => r.data),
  deleteTemplate: (id: string) =>
    apiClient.delete<MessageResponse>(`/support/email-templates/${id}`).then((r) => r.data),
  previewTemplate: (id: string, data: AdminEmailPreviewRequest) =>
    apiClient.post<AdminEmailPreviewResponse>(`/support/email-templates/${id}/preview`, data).then((r) => r.data),
};
